import React from 'react'
import ApplicationForm from './ApplicationForm'

export const Career = () => {
  return (
    <div>
    <ApplicationForm />
    </div>
  )
}
